import {Stack, Typography} from '@mui/material';
import {Modal} from '../../modal/modal';
import {translations} from '../../../i18n/translations';
import {useTranslation} from 'react-i18next';
import './applications-state-modal.scss';

type ApplicationsStateModalProps = {
  open: boolean;
  state: 'enable' | 'disable';
  applicationName: string;
  description: string;
  onClose: () => void;
  onConfirm: () => void;
};

export const ApplicationsStateModal = ({
  open,
  state,
  applicationName,
  description,
  onClose,
  onConfirm,
}: ApplicationsStateModalProps) => {
  const {t} = useTranslation();
  return (
    <Modal
      className="applications-state-modal"
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      preventCloseClick
      actions={[
        {
          label: t(translations.modal.cancel),
          type: 'destructive',
          onClick: onClose,
        },
        {
          label: t(translations.modal.confirm),
          type: 'nondestructive',
          onClick: onConfirm,
        },
      ]}
    >
      <Stack>
        <Typography className="title">
          {t(translations.user_applications[`${state}_application_dialog_title`], {
            name: applicationName,
          })}
        </Typography>
        <Typography className="subtitle">{description}</Typography>
      </Stack>
    </Modal>
  );
};
